import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Button, Spinner } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import MetaTags from "react-meta-tags";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from '../BaseUrl/ApiClient';
import '../LimitedTimeDeals/LTDealDetail.css';

function DSDealDetail() {
    const { dealId } = useParams();
    const [deal, setDeal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDealDetails = async () => {
        setLoading(true);
        setError(null);
        try {
            const client = ApiClient();
            const response = await client.get(`business/deal/dailySpecials/${dealId}`);
            const fetchedDeal = response.data.responseData.deal;
            setDeal(fetchedDeal);
        } catch (err) {
            setError('Failed to fetch deal details. Please try again.');
            toast.error('Failed to fetch deal details.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (dealId) {
            fetchDealDetails();
        }
    }, [dealId]);

    if (loading) {
        return (
            <div className="page-content">
                <Container fluid className="mt-5">
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '320px' }}>
                        <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                        <h5 className="mt-3 text-muted">Loading Deal Details...</h5>
                    </div>
                </Container>
            </div>
        );
    }

    if (error || !deal) {
        return (
            <div className="page-content">
                <Container fluid className="mt-5">
                    <div className="text-center">
                        <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="secondary:#121331,secondary:#08a88a"
                            style={{ width: '75px', height: '75px' }}
                        ></lord-icon>
                        <h5 className="mt-2">Sorry! No Deal Found</h5>
                        <p className="text-muted mb-0">{error || 'No deal data available.'}</p>
                    </div>
                </Container>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="mt-5">
                    <MetaTags>
                        <title>Daily Special Detail</title>
                    </MetaTags>
                    <ToastContainer />

                    <div className="mb-3">
                        <Link to="/deal-list">
                            <Button color="primary" className="ltd-back-btn">
                                <i className="mdi mdi-arrow-left"></i> Back to Deals
                            </Button>
                        </Link>
                    </div>

                    <div className="ltd-detail-card">
                        <Row className="g-0">
                            <Col lg="5" md="5">
                                <div className="ltd-image-wrap">
                                    <span className={`ltd-active-badge ${deal.isActive ? 'active' : 'inactive'}`}>
                                        <span className="dot"></span>
                                        {deal.isActive ? 'Available' : 'Unavailable'}
                                    </span>
                                    {deal.dealPhoto?.url ? (
                                        <img
                                            src={deal.dealPhoto.url}
                                            alt={deal.name}
                                            className="ltd-image"
                                        />
                                    ) : (
                                        <span className="ltd-image-placeholder">No image available</span>
                                    )}
                                </div>
                            </Col>

                            <Col lg="7" md="7">
                                <div className="ltd-body">
                                    <span className="ltd-eyebrow">
                                        <i className="mdi mdi-silverware-fork-knife"></i> Daily Special
                                    </span>
                                    <h1 className="ltd-title">{deal.name}</h1>

                                    <div className="ltd-info-grid">
                                        <div className="ltd-info-tile">
                                            <div className="ltd-info-icon">
                                                <i className="mdi mdi-currency-usd"></i>
                                            </div>
                                            <div className="ltd-info-meta">
                                                <span className="ltd-info-label">Price</span>
                                                <span className="ltd-info-value">$ {deal.price || 'N/A'}</span>
                                            </div>
                                        </div>

                                        <div className="ltd-info-tile">
                                            <div className="ltd-info-icon">
                                                <i className="mdi mdi-tag-outline"></i>
                                            </div>
                                            <div className="ltd-info-meta">
                                                <span className="ltd-info-label">Category</span>
                                                <span className="ltd-info-value">
                                                    {deal.category?.categoryLogo?.url && (
                                                        <img
                                                            src={deal.category.categoryLogo.url}
                                                            alt={deal.category?.name}
                                                            className="ltd-cat-logo"
                                                        />
                                                    )}
                                                    {deal.category?.name || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ltd-section-title">Available Days</div>
                                    <div className="ltd-pills">
                                        {deal.days && deal.days.length > 0 ? (
                                            deal.days.map((day, index) => (
                                                <span key={index} className="ltd-day-pill">{day}</span>
                                            ))
                                        ) : (
                                            <span className="ltd-empty">No days specified</span>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default DSDealDetail;
